import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import successIcon from '../../../assets/images/SVG/sucess.svg';

const SuccessModal = ({
    isOpen,
    onClose,
    title = 'Password Changed Successfully!',
    description = 'Your password has been updated. You can now sign in using your new credentials.',
    actionText = 'Login',
    onAction,
    showCloseButton = true
}) => {
    const handleActionClick = () => {
        if (onAction) {
            onAction();
        } else if (onClose) {
            onClose();
        }
    };

    return (
        <Dialog
            open={isOpen}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason === 'backdropClick') return;
                if (onClose) onClose();
            }}
            disableScrollLock
            sx={{
                '& .MuiBackdrop-root': {
                    backgroundColor: 'rgba(15, 23, 42, 0.4)',
                    backdropFilter: 'blur(8px)',
                },
                '& .MuiPaper-root': {
                    borderRadius: '24px !important',
                    width: '100%',
                    maxWidth: '460px',
                    margin: '16px',
                    boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.15)',
                    border: '1px solid rgba(255, 255, 255, 0.8)',
                    fontFamily: "'Poppins', sans-serif",
                    overflow: 'visible',
                    position: 'relative',
                    p: { xs: 2.5, sm: 3 },
                    pt: { xs: 4, sm: 5 }
                }
            }}
        >
            {/* Top Right Close Button */}
            {showCloseButton && onClose && (
                <IconButton
                    onClick={onClose}
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 20,
                        top: 20,
                        color: '#94a3b8',
                        transition: 'all 0.25s',
                        '&:hover': {
                            color: '#64748b',
                            backgroundColor: '#f1f5f9'
                        }
                    }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </IconButton>
            )}

            <DialogContent sx={{ p: 0, textAlign: 'center' }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {/* Centered Success SVG */}
                    <Box
                        component="img"
                        src={successIcon}
                        alt="Success"
                        sx={{
                            width: '80px',
                            height: '80px',
                            mb: 3,
                            filter: 'drop-shadow(0 10px 15px rgba(70, 204, 107, 0.2))'
                        }}
                    />

                    {/* Title */}
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            color: '#1e1b4b', // deep premium charcoal/indigo
                            mb: 1.5,
                            fontSize: { xs: '20px', sm: '22px' },
                            fontFamily: "'Poppins', sans-serif"
                        }}
                    >
                        {title}
                    </Typography>

                    {/* Description */}
                    <Typography
                        sx={{
                            color: '#64748b', // soft slate blue
                            fontSize: '14px',
                            lineHeight: 1.6,
                            mb: 4,
                            maxWidth: '340px',
                            fontFamily: "'Poppins', sans-serif"
                        }}
                    >
                        {description}
                    </Typography>

                    {/* Reusable Action Button */}
                    <Button
                        onClick={handleActionClick}
                        variant="contained"
                        sx={{
                            backgroundColor: '#ff502d',
                            color: '#ffffff',
                            borderRadius: '16px',
                            width: '100%',
                            maxWidth: '240px',
                            py: 1.5,
                            fontSize: '15px',
                            fontWeight: 600,
                            textTransform: 'none',
                            boxShadow: '0 8px 20px -6px rgba(255, 80, 45, 0.4)',
                            fontFamily: "'Poppins', sans-serif",
                            '&:hover': {
                                backgroundColor: '#e04324',
                                boxShadow: '0 12px 24px -6px rgba(255, 80, 45, 0.5)',
                                transform: 'translateY(-2px)'
                            },
                            '&:active': {
                                transform: 'translateY(0)'
                            },
                            transition: 'all 0.25s ease'
                        }}
                    >
                        {actionText}
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default SuccessModal;
